import styled from '@emotion/styled';
import { Fab } from '@mui/material';

interface AsyncImageStyleProps {
  imgHeight?: number | string;
  imgWidth?: number | string;
  isEnlargedImageAvailable?: boolean;
}

export const AsyncImageContainer = styled.div<AsyncImageStyleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #fff;
  border-radius: 1rem;
  height: ${({ imgHeight }) => (typeof imgHeight === 'number' ? `${imgHeight}rem` : imgHeight)};
  width: ${({ imgWidth }) => (typeof imgWidth === 'number' ? `${imgWidth}rem` : imgWidth)};

  &:hover {
    cursor: ${({ isEnlargedImageAvailable }) => (isEnlargedImageAvailable ? 'pointer' : 'inherit')};
  }
`;

export const AsyncImageStyle = styled.img`
  object-fit: contain;
  width: 90%;
  height: 90%;
`;

export const EditButtonStyle = styled(Fab)`
  margin: 0;
  inset: auto 0 0 auto;
  position: absolute;
`;

export const AsyncImageFailContainer = styled.div`
  white-space: pre-wrap;
`;
